export const HANDS_FREE_KIT = 41;
export const MP3 = 133;
export const NAVIGATION_SYSTEM = 11;
export const CD_PLAYER = 7;
export const HAS_CD_MULTICHANGER = 'hasCDMultichanger';
export const HAS_INTEGRATED_MUSIC_STREAMING = 'hasIntegratedMusicStreaming';
export const HAS_TV = 'hasTV';
export const HAS_WIFI_HOTSPOT = 'hasWifiHotSpot';
export const HAS_TOUCHSCREEN = 'hasTouchscreen';
export const HAS_VIRTUAL_COCKPIT = 'hasVirtualCockpit';
export const HAS_ANDROID_PHONE_CONNECTION = 'hasAndroidPhoneConnection';
export const HAS_APPLE_CARPLAY = 'hasAppleCarplay';
export const HAS_BLUETOOTH = 'hasBluetooth';
export const HAS_SMARTPHONE_INDUCTION_CHARGER = 'hasSmartphoneInductionCharger';
